import React from 'react'

export const NoMatch = () => (
  <div>
    <h2>Error 404 page not found</h2>
  </div>
)
